import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as FacturacionService from 'services/facturacion.service'

import { DownloadAxiosFile } from 'utils'

const ReporteUtilidad = () => {
  const __zariContext = React.useContext(ZariContext)

  const [fechaDesde, setfechaDesde] = React.useState(new Date())
  const [fechaHasta, setfechaHasta] = React.useState(new Date())

  const clickDescargar = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte utilidad...')
    FacturacionService.descargarReporteUtilidad({
      fechaDesde,
      fechaHasta
    })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, fechaDesde, fechaHasta])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Utilidad' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Desde' htmlFor='desde' md={4} />
              <Col md={6}>
                <Form.InputDate
                  value={fechaDesde}
                  name='fechaDesde'
                  id='date-desde'
                  onChange={e => setfechaDesde(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Hasta' htmlFor='hasta' md={4} />
              <Col md={6}>
                <Form.InputDate
                  value={fechaHasta}
                  name='fechaHasta'
                  id='date-hasta'
                  onChange={e => setfechaHasta(e.target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargar}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteUtilidad)
